<template>
  <nav>
    <v-navigation-drawer v-model="drawer"
                         :clipped="true"
                         app
                         :expand-on-hover="$vuetify.breakpoint.mdAndUp"
                         :mini-variant="$vuetify.breakpoint.mdAndUp"
                         >
<!--      :clipped="$vuetify.breakpoint.lgAndUp"-->
<!--&lt;!&ndash;      <v-list-item>&ndash;&gt;-->
<!--&lt;!&ndash;        <v-list-item-content>&ndash;&gt;-->
<!--&lt;!&ndash;          <v-list-item-title class="text-h6">&ndash;&gt;-->
<!--&lt;!&ndash;            Application&ndash;&gt;-->
<!--&lt;!&ndash;          </v-list-item-title>&ndash;&gt;-->
<!--&lt;!&ndash;          <v-list-item-subtitle>&ndash;&gt;-->
<!--&lt;!&ndash;            subtext&ndash;&gt;-->
<!--&lt;!&ndash;          </v-list-item-subtitle>&ndash;&gt;-->
<!--&lt;!&ndash;        </v-list-item-content>&ndash;&gt;-->
<!--&lt;!&ndash;      </v-list-item>&ndash;&gt;-->


<!--      &lt;!&ndash;          <v-btn to="/">Home</v-btn>&ndash;&gt;-->
<!--      &lt;!&ndash;          <v-btn to="/about">BMS</v-btn>&ndash;&gt;-->
<!--      &lt;!&ndash;          <v-btn to="/about">Systems</v-btn>&ndash;&gt;-->
<!--      &lt;!&ndash;          <v-btn to="/about">About</v-btn>&ndash;&gt;-->

<!--&lt;!&ndash;      <v-divider></v-divider>&ndash;&gt;-->

      <v-list
          nav
          dense
      >
        <v-list-item to="/">
          <v-list-item-icon>
            <v-icon>mdi-home</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Hjem</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to="/bms">
          <v-list-item-icon>
            <v-icon>mdi-brain</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Intelligente bygg</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

<!--        <v-list-item to="/systems">-->
<!--          <v-list-item-icon>-->
<!--            <v-icon>mdi-car</v-icon>-->
<!--          </v-list-item-icon>-->
<!--          <v-list-item-content>-->
<!--            <v-list-item-title>Digital kjørebok</v-list-item-title>-->
<!--          </v-list-item-content>-->
<!--        </v-list-item>-->

<!--        <v-list-item to="/sensors">-->
<!--          <v-list-item-icon>-->
<!--            <v-icon>mdi-access-point</v-icon>-->
<!--          </v-list-item-icon>-->
<!--          <v-list-item-content>-->
<!--            <v-list-item-title>Sensorer</v-list-item-title>-->
<!--          </v-list-item-content>-->
<!--        </v-list-item>-->

<!--        <v-list-item to="/development">-->
<!--          <v-list-item-icon>-->
<!--            <v-icon>mdi-cog</v-icon>-->
<!--          </v-list-item-icon>-->
<!--          <v-list-item-content>-->
<!--            <v-list-item-title>Utvikling</v-list-item-title>-->
<!--          </v-list-item-content>-->
<!--        </v-list-item>-->

        <v-list-item to="/about">
          <v-list-item-icon>
            <v-icon>mdi-information</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Om oss</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to="/faq">
          <v-list-item-icon>
            <v-icon>mdi-help-circle</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Ofte stilte spørsmål</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>
        <v-list-item flat dense>

          <v-list-item-title>
            <v-icon>mdi-login</v-icon>
            Logg inn

          </v-list-item-title>
        </v-list-item>
        <v-list-item @click="onLinkClick('https://dashboard.sitesense.no/')">
          <v-list-item-icon>
            <v-icon>mdi-monitor-dashboard</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>BMS</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item @click="onLinkClick('https://systems.sitesense.no/')">
          <v-list-item-icon>
            <v-icon>mdi-car</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Digital kjørebok</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

<!--    <v-app-bar-->
<!--        :clipped-left="$vuetify.breakpoint.lgAndUp"-->
    <v-app-bar class="primary"
        :clipped-left="true"

        app
               dense
               dark
        >
      <v-row class="align-center">
<!--        <v-col>-->
<!--          <v-app-bar-nav-icon v-show="$vuetify.breakpoint.smAndDown" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>-->

<!--        </v-col>-->
<!--        <v-col>-->
<!--          <v-btn plain depressed rounded to="/" style="padding: 2em">-->
<!--            <v-img style="max-width: 150px; margin: 1em" src="../assets/SiteSense-Logo-Web-Png-2.png"></v-img>-->
<!--          </v-btn>-->
<!--        </v-col>-->

        <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>

<!--          <v-btn plain depressed rounded to="/" style="padding: 2em">-->
          <v-btn plain depressed rounded to="/" >

            <v-app-bar-title>
              SiteSense
            </v-app-bar-title>
<!--            <v-img style="max-width: 150px; margin: 1em" src="../assets/SiteSense-Logo-Web-Png-2.png"></v-img>-->
          </v-btn>
<!--        <v-spacer></v-spacer>-->
<!--          <v-img src="../assets/sitesense_logo.png" max-width="150px"></v-img>-->
<!--        </v-app-bar-title>-->

<!--        <template v-if="$vuetify.breakpoint.mdAndUp">-->

<!--          <v-col>-->
<!--            <v-btn rounded text>-->
<!--              BMS-->
<!--&lt;!&ndash;              <v-icon>mdi-login</v-icon>&ndash;&gt;-->
<!--            </v-btn>-->
<!--          </v-col>-->
<!--          <v-col>-->
<!--            <v-btn rounded text>-->
<!--              Digital kjørebok-->
<!--&lt;!&ndash;              <v-icon>mdi-login</v-icon>&ndash;&gt;-->
<!--            </v-btn>-->
<!--          </v-col>-->
<!--          <v-col>-->
        <v-spacer></v-spacer>
            <v-btn rounded text @click="$vuetify.goTo(target, options)">Kontakt
<!--              <v-icon>mdi-chevron-down</v-icon>-->
            </v-btn>
<!--          </v-col>-->
<!--        </template>-->
<!--        <v-col>-->
          <v-btn icon @click="onDarkSet">
            <v-icon>
              mdi-brightness-6
            </v-icon>
          </v-btn>
<!--        </v-app-bar-title>-->
<!--        </v-col>-->

      </v-row>


<!--      <template v-slot:img="{ props }">-->
<!--        <v-img v-show="$vuetify.breakpoint.mdAndUp" src="../assets/sitesense_logo.png" max-height="80%" contain-->
<!--            v-bind="props"-->
<!--        ></v-img>-->
<!--      </template>-->

<!--      <v-app-bar-nav-icon v-show="$vuetify.breakpoint.smAndDown" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>-->
<!--      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>-->


<!--      <v-img contain></v-img>-->
<!--      <v-card>-->
<!--        <v-card-title>-->
<!--          To BMS-->
<!--        </v-card-title>-->
<!--      </v-card>-->
<!--      <v-card>-->
<!--        <v-card-title>-->
<!--          To Systems-->
<!--        </v-card-title>-->
<!--      </v-card>-->
<!--          <v-btn>Home</v-btn>-->
<!--      <v-row>-->
<!--        <v-col>-->
<!--        <v-card>-->
<!--      <template v-if="$vuetify.breakpoint.mdAndUp">-->
<!--        <v-btn rounded depressed to="/">Home</v-btn>-->
<!--        <v-btn rounded depressed to="/bms">BMS</v-btn>-->
<!--        <v-btn rounded depressed to="/systems">Systems</v-btn>-->
<!--        <v-btn rounded depressed to="/about">About</v-btn>-->
<!--        <v-btn rounded depressed @click="$vuetify.goTo(target, options)">Contact</v-btn>-->

<!--      </template>-->
<!--        </v-col>-->
<!--      </v-row>-->
<!--      <v-row>-->
<!--        <v-col>-->
<!--          <v-btn style="color: white" to="/">Home</v-btn>-->
<!--        </v-col>-->
<!--        <v-col>-->
<!--          <v-btn style="color: white" to="/about">BMS</v-btn>-->
<!--        </v-col>-->
<!--        <v-col>-->
<!--          <v-btn style="color: white" to="/about">Systems</v-btn>-->
<!--        </v-col>-->
<!--        <v-col>-->
<!--          <v-btn style="color: white" to="/about">About</v-btn>-->
<!--        </v-col>-->
<!--      </v-row>-->

<!--      <v-spacer></v-spacer>-->

<!--      <v-btn @click="onOpenChat()" class="mx-2" color="primary" rounded depressed>-->
<!--        <v-badge :content="num_unread" :value="unread">-->
<!--        <v-icon>mdi-chat</v-icon>-->
<!--        </v-badge>-->
<!--      </v-btn>-->

    </v-app-bar>
<!--    <v-dialog v-model="chat" max-width="500px">-->
<!--      <v-card style="width: 100%; height: 400px">-->
<!--      </v-card>-->
<!--    </v-dialog>-->
  </nav>
</template>

<script>

import * as easings from 'vuetify/lib/services/goto/easing-patterns'

export default {
  name: "NavBar",
  data: () => ({
    drawer: false,
    num_unread: 1,
    unread: true,
    chat: false,


    type: 'number',
    number: 999,
    selector: '#first',
    selections: ['#first', '#second', '#third'],
    selected: 'Button',
    elements: ['Button', 'Radio group'],
    duration: 300,
    offset: 0,
    easing: 'easeInOutCubic',
    easings: Object.keys(easings),
  }),
  methods: {
    onLinkClick(context) {
      console.log('link click ', context)
      window.open(context)
    },
    onDarkSet() {
      if (localStorage.getItem('DarkMode')) {
        localStorage.removeItem('DarkMode')
      } else {
        localStorage.setItem('DarkMode', 'true')
      }
      this.$router.go(0)
    },
    onLogoClick() {
      this.$router.push("home-view")
    },
    onOpenChat() {
      this.chat = true
      this.unread = false
    }
  },
  computed: {
    target () {
      return "footer"
      // const value = this[this.type]
      // if (!isNaN(value)) return Number(value)
      // else return value
    },
    options () {
      return {
        duration: this.duration,
        offset: this.offset,
        easing: this.easing,
      }
    },
    // element () {
    //   if (this.selected === 'Button') return this.$refs.button
    //   else if (this.selected === 'Radio group') return this.$refs.radio
    //   else return null
    // },
  },
}
</script>

<style scoped>
.v-btn {
  text-transform:none !important;
}
</style>
